import type { ICellRendererParams } from 'ag-grid-community'
import type { ReactElement } from 'react'
import type { ITemplateRowData } from '~/types/template'

import './styles.scss'

const TemplateKeyCellRenderer = ({ data }: ICellRendererParams<ITemplateRowData>): ReactElement => {
  if (!data) return <div />

  const { templateKey, title } = data

  return (
    <div className="template-key-cell-renderer">
      <span className="text">{title}</span>
      <span className="sub-text text">{templateKey}</span>
    </div>
  )
}

export default TemplateKeyCellRenderer
